import { mapState } from 'vuex';

import { PasswordWithStrength } from 'ipro-ui-kit-vuejs/src/components';

import { AuthService } from '@/auth';
import { AuthRoutes } from '@/auth/mixins';

// @vue/component
export default {
  components: {
    PasswordWithStrength,
  },
  mixins: [
    AuthRoutes,
  ],
  data() {
    return {
      inputs: {
        first_name: {
          properties: {
            label: 'First name',
            'label-icon': 'far fa-user',
            name: 'first_name',
            required: true,
            'tooltip-text': 'We respect your privacy and are committed to protecting your private information. Your name is used to personalise communication.',
            'validation-rules': 'required',
          },
          value: this.$route.query.first_name,
        },
        last_name: {
          properties: {
            label: 'Last name',
            'label-icon': 'far fa-user',
            name: 'last_name',
            required: true,
            'tooltip-text': 'We respect your privacy and are committed to protecting your private information. Your name is used to personalise communication.',
            'validation-rules': 'required',
          },
          value: this.$route.query.last_name,
        },
        password: {
          properties: {
            label: 'Password',
            name: 'password',
            required: true,
          },
          value: '',
        },
      },
      requestInProgress: false,
    };
  },
  computed: {
    ...mapState({
      privacyPolicyLink: state => state.config.privacyPolicyLink,
      termsAndConditionsLink: state => state.config.termsAndConditionsLink,
    }),
    uuid() {
      return this.$route.query.user_uuid;
    },
    confirmation_token() {
      return this.$route.query.confirmation_token;
    },
  },
  created() {
    if (!(this.uuid && this.confirmation_token)) {
      this.$router.replace(this.routes.login);
    }
  },
  methods: {
    async activate() {
      this.requestInProgress = true;

      try {
        const credentials = {
          first_name: this.inputs.first_name.value,
          last_name: this.inputs.last_name.value,
          password: this.inputs.password.value,
          uuid: this.uuid,
          confirmation_token: this.confirmation_token,
        };
        const user = await AuthService.activate(credentials);
        await AuthService.login({ login: user.email, password: credentials.password });

        this.$router.push(this.routes.redirect);
      } catch (error) {
        // Do nothing
      }

      this.requestInProgress = false;
    },
  },
};
